<template>
    <div v-loading="loading" class="deposit-refund-page">
        <HeaderDepositRefundList @openImport="showImport = true"/>
        <hr class="deposit-refund-page__divider"/>

        <div class="deposit-refund-page__body">
            <div class="grid-filter">
                <div class="display-flex-column">
                    <span>Học viên</span>
                    <el-input
                        v-model="query.keyword"
                        clearable
                        placeholder="Nhập tên, số điện thoại, mã học viên"
                        suffix-icon="el-icon-search"
                        @change="handleSearch"
                        @clear="handleSearch"
                    />
                </div>

                <div class="display-flex-column">
                    <span>Thời gian</span>
                    <el-date-picker
                        v-model="query.time_range"
                        clearable
                        end-placeholder="Đến ngày"
                        format="dd/MM/yyyy"
                        placeholder="Chọn thời gian"
                        range-separator="-"
                        start-placeholder="Từ ngày"
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        @change="handleSearch"
                    />
                </div>

                <div class="display-flex-column">
                    <span>Trạng thái</span>
                    <el-select
                        v-model="query.status"
                        clearable
                        collapse-tags
                        multiple
                        placeholder="Chọn trạng thái"
                        style="width: 100%"
                        @change="handleSearch"
                        @clear="handleSearch"
                    >
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
            </div>

            <div class="deposit-refund-table-wrap">
                <table class="table table-bordered deposit-refund-table">
                    <thead>
                    <tr>
                        <th>Mã HĐ</th>
                        <th>Học viên</th>
                        <th>Số điện thoại</th>
                        <th>Lớp chính</th>
                        <th>Lớp BTCT 1</th>
                        <th>Lớp BTCT 2</th>
                        <th>Nhân sự phụ trách</th>
                        <th class="text-center">Tổng lỗi</th>
                        <th>Tiền cần hoàn</th>
                        <th class="text-center">Trạng thái</th>
                        <th>Thời gian hoàn</th>
                        <th class="text-center">Hành động</th>
                    </tr>
                    </thead>

                    <tbody v-if="records.length > 0">
                    <tr v-for="item of records" :key="item.id">
                        <td>{{ item.contractCode }}</td>
                        <td class="cell-student">
                            <span class="cell-student__name">{{ item.studentName }}</span>
                            <span v-if="item.studentCode" class="cell-student__code">- {{ item.studentCode }}</span>
                        </td>
                        <td>{{ item.phone || "—" }}</td>
                        <td>{{ item.mainClassName || "—" }}</td>
                        <td>{{ item.supplementaryClass1Name || "—" }}</td>
                        <td>{{ item.supplementaryClass2Name || "—" }}</td>
                        <td>{{ item.assignedStaffName || "—" }}</td>
                        <td class="text-center">{{ item.totalErrors }}</td>
                        <td class="cell-amount">{{ formatCurrency(item.refundAmount) }}</td>
                        <td class="text-center">
                <span :class="item.processingStatusClass" class="refund-status-badge">
                  {{ item.processingStatusLabel }}
                </span>
                        </td>
                        <td>{{ item.refundedAt || "—" }}</td>
                        <td>
                            <div class="action-cell">
                                <button
                                    class="btn btn-icon btn-xs btn-outline-primary"
                                    title="Xem chi tiết"
                                    type="button"
                                    @click="onViewDetail(item)"
                                >
                                    <i class="el-icon-view"></i>
                                </button>
                                <button
                                    v-if="item.showRequestRefundAction"
                                    class="btn btn-icon btn-xs btn-outline-primary"
                                    title="Yêu cầu hoàn"
                                    type="button"
                                    @click="onRequestRefund(item)"
                                >
                                    <i class="el-icon-document-add"></i>
                                </button>
                                <button
                                    v-if="item.showApproveAction"
                                    class="btn btn-icon btn-xs btn-outline-success"
                                    title="Duyệt hoàn"
                                    type="button"
                                    @click="onApproveRefund(item)"
                                >
                                    <i class="el-icon-check"></i>
                                </button>
                                <button
                                    v-if="item.showRejectAction"
                                    class="btn btn-icon btn-xs btn-outline-danger"
                                    title="Từ chối duyệt"
                                    type="button"
                                    @click="onRejectRefund(item)"
                                >
                                    <i class="el-icon-close"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>

                    <tbody v-else>
                    <tr>
                        <td class="empty-cell" colspan="12">Không có dữ liệu</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="total > 0" class="deposit-refund-footer">
                <div class="deposit-refund-footer__paginate">
                    <paginate
                        v-model="page"
                        :click-handler="changePage"
                        :container-class="'pagination b-pagination'"
                        :margin-pages="1"
                        :next-class="'page-link'"
                        :next-link-class="'next-link-item'"
                        :next-text="'Sau'"
                        :page-class="'page-item'"
                        :page-count="lastPage"
                        :page-range="3"
                        :pageLinkClass="'page-link'"
                        :prev-class="'page-link'"
                        :prev-link-class="'prev-link-item'"
                        :prev-text="'Trước'"
                    />
                </div>
                <div class="deposit-refund-footer__total">
                    Tổng số bản ghi:
                    <span>{{ total }}</span>
                </div>
            </div>
        </div>

        <el-dialog
            v-if="showImport"
            :show-close="false"
            :title="titleDialogImportDepositRefund"
            :visible.sync="showImport"
            top="8vh"
            width="50%"
        >
            <hr class="deposit-refund-page__divider dialog-divider"/>
            <DialogImportDepositRefund
                @closeDialog="closeImportDialog"
                @reload="reloadList"
                @setTitleError="setImportDialogTitle"
            />
        </el-dialog>

        <el-dialog
            v-loading="loadingRequestRefundBank"
            :show-close="false"
            :title="'Yêu cầu hoàn cọc KH: ' + selectedRecord?.studentName"
            :visible.sync="showRequestRefundDialog"
            append-to-body
            custom-class="request-refund-el-dialog"
            destroy-on-close
            top="4vh"
            width="540px"
        >
            <DialogRequestDepositRefund
                :bank-account-name="requestRefundBank.bankAccountName"
                :bank-account-number="requestRefundBank.bankAccountNumber"
                :bank-name="requestRefundBank.bankName"
                :submitting="submittingRequestRefund"
                @closeDialog="closeRequestRefundDialog"
                @submit="handleSubmitRequestRefund"
            />
        </el-dialog>

        <el-dialog
            :show-close="false"
            :visible.sync="showRejectRefundDialog"
            append-to-body
            custom-class="request-refund-el-dialog"
            destroy-on-close
            title="Xử lý từ chối hoàn"
            top="8vh"
            width="540px"
        >
            <DialogRejectDepositRefund
                :accounting-reject-reason="selectedRecord?.raw?.accounting_reject_reason"
                :submitting="submittingRejectRefund"
                @closeDialog="closeRejectRefundDialog"
                @submit="handleSubmitRejectRefund"
            />
        </el-dialog>

        <el-dialog
            :show-close="false"
            :title="'Duyệt hoàn cọc KH: ' + selectedRecord?.studentName"
            :visible.sync="showApproveRefundDialog"
            append-to-body
            custom-class="request-refund-el-dialog"
            destroy-on-close
            top="8vh"
            width="540px"
        >
            <DialogApproveDepositRefund
                :refund-amount="selectedRecord?.refundAmount"
                :submitting="submittingApproveRefund"
                @closeDialog="closeApproveRefundDialog"
                @submit="handleSubmitApproveRefund"
            />
        </el-dialog>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
    CREATE_DEPOSIT_REFUND,
    GET_LIST_DEPOSIT_REFUND,
    REVIEW_DEPOSIT_REFUND,
} from "@/core/services/store/deposit-refund/depositRefund.module";
import {GET_USER_BY_ID} from "@/core/services/store/user/users.module";
import {DepositRefundModel, STATUS_OPTIONS} from "./model/DepositRefundModel";
import HeaderDepositRefundList from "./component/HeaderDepositRefundList.vue";
import DialogImportDepositRefund from "./component/DialogImportDepositRefund.vue";
import DialogRequestDepositRefund from "./component/DialogRequestDepositRefund.vue";
import DialogRejectDepositRefund from "./component/DialogRejectDepositRefund.vue";
import DialogApproveDepositRefund from "./component/DialogApproveDepositRefund.vue";

export default {
    name: "DepositRefundList",
    components: {
        HeaderDepositRefundList,
        DialogImportDepositRefund,
        DialogRequestDepositRefund,
        DialogRejectDepositRefund,
        DialogApproveDepositRefund,
    },
    data() {
        return {
            loading: false,
            showImport: false,
            titleDialogImportDepositRefund: "Import đề xuất hoàn phí bổ trợ cấp tốc",
            showRequestRefundDialog: false,
            showRejectRefundDialog: false,
            showApproveRefundDialog: false,
            submittingRequestRefund: false,
            loadingRequestRefundBank: false,
            submittingRejectRefund: false,
            submittingApproveRefund: false,
            requestRefundBank: {
                bankAccountNumber: "",
                bankAccountName: "",
                bankName: "",
            },
            page: 1,
            lastPage: 1,
            total: 0,
            records: [],
            selectedRecord: null,
            statusOptions: STATUS_OPTIONS,
            query: {
                keyword: null,
                time_range: null,
                status: [],
            },
        };
    },
    computed: {
        ...mapGetters(["currentUser"]),
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý tài chính"},
            {title: "Quản lý phí khác"},
            {title: "Phí bổ trợ"},
        ]);
        this.getParams();
        this.reloadList();
    },
    methods: {
        can(code) {
            return this.currentUser?.user?.permission?.includes(code) ?? false;
        },
        closeImportDialog() {
            this.showImport = false;
            this.titleDialogImportDepositRefund = "Import đề xuất hoàn phí bổ trợ cấp tốc";
        },
        setImportDialogTitle(title) {
            this.titleDialogImportDepositRefund = title;
        },
        formatCurrency(amount) {
            if (amount === null || amount === undefined || amount === "") return "—";
            const num = Number(amount);
            return Number.isNaN(num) ? amount : `${num.toLocaleString("vi-VN")} đ`;
        },
        changePage(p) {
            this.page = p;
            this.reloadList();
        },
        parseStatusFromQuery(status) {
            if (status === undefined || status === null || status === "") return [];
            if (Array.isArray(status)) {
                return status.map((s) => Number(s)).filter((n) => !Number.isNaN(n));
            }
            try {
                return JSON.parse(`[${status}]`)
                    .map((s) => Number(s))
                    .filter((n) => !Number.isNaN(n));
            } catch {
                const n = Number(status);
                return Number.isNaN(n) ? [] : [n];
            }
        },
        statusQueryForApi() {
            return Array.isArray(this.query.status) && this.query.status.length
                ? this.query.status
                : null;
        },
        async pushParams() {
            await this.$router.push({
                name: "PhiBoTroFeeList",
                query: {
                    keyword: this.query.keyword || undefined,
                    status: this.statusQueryForApi(),
                    from_date: this.query.time_range?.[0] ?? undefined,
                    to_date: this.query.time_range?.[1] ?? undefined,
                },
            });
        },
        getParams() {
            const q = this.$route.query || {};
            this.query.keyword = q.keyword ?? null;
            this.query.status = this.parseStatusFromQuery(q.status);
            const from = q.from_date ?? null;
            const to = q.to_date ?? null;
            this.query.time_range = from && to ? [from, to] : null;
            if (q.page) {
                const p = Number(q.page);
                if (!Number.isNaN(p) && p > 0) this.page = p;
            }
        },
        async handleSearch() {
            this.page = 1;
            await this.pushParams();
            this.reloadList();
        },
        async reloadList() {
            this.getParams();
            this.loading = true;
            try {
                const res = await this.$store.dispatch(GET_LIST_DEPOSIT_REFUND, {
                    page: this.page,
                    per_page: 20,
                    keyword: this.query.keyword,
                    status: this.statusQueryForApi(),
                    from_date: this.query.time_range?.[0] ?? null,
                    to_date: this.query.time_range?.[1] ?? null,
                });
                if (!res?.error) {
                    let rows = [];
                    if (res?.pagination) {
                        rows = Array.isArray(res.data) ? res.data : [];
                        this.page = res.pagination.current_page ?? this.page;
                        this.lastPage = res.pagination.last_page ?? 1;
                        this.total = res.pagination.total ?? 0;
                    } else {
                        const pageObj = res?.data?.data ? res.data : res?.data;
                        rows = pageObj?.data ?? (Array.isArray(pageObj) ? pageObj : []);
                        this.page = pageObj?.current_page ?? this.page;
                        this.lastPage = pageObj?.last_page ?? 1;
                        this.total = pageObj?.total ?? 0;
                    }
                    this.records = rows.map((r) => new DepositRefundModel(r));
                } else {
                    this.records = [];
                    this.total = 0;
                }
            } catch {
                this.records = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },
        emptyRequestRefundBank() {
            return {
                bankAccountNumber: "",
                bankAccountName: "",
                bankName: "",
            };
        },
        hasBankData(bank = {}) {
            return Boolean(bank.bankAccountNumber || bank.bankAccountName || bank.bankName);
        },
        async onRequestRefund(item) {
            this.selectedRecord = item;
            this.requestRefundBank = {
                bankAccountNumber: item.bankAccountNumber || "",
                bankAccountName: item.bankAccountName || "",
                bankName: item.bankName || "",
            };

            if (!this.hasBankData(this.requestRefundBank) && item.userId) {
                this.loadingRequestRefundBank = true;
                try {
                    const res = await this.$store.dispatch(GET_USER_BY_ID, item.userId);
                    if (!res?.error) {
                        const userBank = DepositRefundModel.pickUserBank(res.data);
                        if (userBank) {
                            this.requestRefundBank = userBank;
                        }
                    }
                } catch {
                    // Giữ form trống nếu không lấy được thông tin ngân hàng.
                } finally {
                    this.loadingRequestRefundBank = false;
                }
            }

            this.showRequestRefundDialog = true;
        },
        closeRequestRefundDialog(force = false) {
            if (this.submittingRequestRefund && !force) return;
            this.showRequestRefundDialog = false;
            this.selectedRecord = null;
            this.requestRefundBank = this.emptyRequestRefundBank();
        },
        async handleSubmitRequestRefund(payload) {
            if (!this.selectedRecord?.contractId) {
                this.$message.error("Không tìm thấy thông tin hợp đồng để tạo yêu cầu hoàn cọc");
                return;
            }
            const requestPayload = {
                contract_id: this.selectedRecord.contractId,
                refund_reason_type: payload.reason,
                main_class_id: this.selectedRecord.raw?.main_class_id ?? null,
                bank_account_number: payload.bankAccountNumber,
                bank_account_name: payload.bankAccountName,
                bank_name: payload.bankName,
                note: payload.note || null,
            };
            this.submittingRequestRefund = true;
            try {
                const res = await this.$store.dispatch(CREATE_DEPOSIT_REFUND, requestPayload);
                if (res?.error) {
                    this.$message.error(res?.message || "Tạo yêu cầu hoàn cọc thất bại");
                    return;
                }
                this.$message.success("Tạo yêu cầu hoàn cọc thành công");
                this.closeRequestRefundDialog(true);
                this.reloadList();
            } catch (error) {
                const message =
                    error?.data?.message ||
                    error?.message ||
                    "Có lỗi xảy ra khi tạo yêu cầu hoàn cọc";
                this.$message.error(message);
            } finally {
                this.submittingRequestRefund = false;
            }
        },
        onRejectRefund(item) {
            this.selectedRecord = item;
            this.showRejectRefundDialog = true;
        },
        closeRejectRefundDialog(force = false) {
            if (this.submittingRejectRefund && !force) return;
            this.showRejectRefundDialog = false;
            this.selectedRecord = null;
        },
        async handleSubmitRejectRefund(payload) {
            if (!this.selectedRecord?.id) {
                this.$message.error("Không tìm thấy hồ sơ hoàn cọc để xử lý");
                return;
            }
            this.submittingRejectRefund = true;
            try {
                const requestPayload = {
                    deposit_refund_id: this.selectedRecord.id,
                    action: "reject_handling",
                    // Backend maps handling_type=1 => move back to pending approval.
                    handling_type: 1,
                    note: payload?.note?.trim() || null,
                };
                const res = await this.$store.dispatch(REVIEW_DEPOSIT_REFUND, requestPayload);
                if (res?.error) {
                    this.$message.error(res?.message || "Xử lý từ chối hoàn cọc thất bại");
                    return;
                }
                this.$message.success("Xử lý từ chối hoàn cọc thành công");
                this.closeRejectRefundDialog(true);
                this.reloadList();
            } catch (error) {
                const message =
                    error?.data?.message ||
                    error?.message ||
                    "Có lỗi xảy ra khi xử lý từ chối hoàn cọc";
                this.$message.error(message);
            } finally {
                this.submittingRejectRefund = false;
            }
        },
        onApproveRefund(item) {
            this.selectedRecord = item;
            this.showApproveRefundDialog = true;
        },
        closeApproveRefundDialog(force = false) {
            if (this.submittingApproveRefund && !force) return;
            this.showApproveRefundDialog = false;
            this.selectedRecord = null;
        },
        async handleSubmitApproveRefund(payload) {
            if (!this.selectedRecord?.id) {
                this.$message.error("Không tìm thấy hồ sơ hoàn cọc để duyệt");
                return;
            }
            const processingStatus = Number(payload.processingStatus);
            const isRejectAction = processingStatus === 3;
            const note = (payload?.note ?? "").trim() || null;
            const requestPayload = {
                deposit_refund_id: this.selectedRecord.id,
                action: isRejectAction ? "reject" : "approve",
                processing_status: processingStatus,
                note: !isRejectAction ? note : null,
                rejection_note: isRejectAction ? note : null,
            };
            this.submittingApproveRefund = true;
            try {
                const res = await this.$store.dispatch(REVIEW_DEPOSIT_REFUND, requestPayload);
                if (res?.error) {
                    this.$message.error(res?.message || "Duyệt hoàn cọc thất bại");
                    return;
                }
                this.$message.success("Cập nhật trạng thái duyệt hoàn cọc thành công");
                this.closeApproveRefundDialog(true);
                this.reloadList();
            } catch (error) {
                const message =
                    error?.data?.message ||
                    error?.message ||
                    "Có lỗi xảy ra khi duyệt hoàn cọc";
                this.$message.error(message);
            } finally {
                this.submittingApproveRefund = false;
            }
        },
        onViewDetail(item) {
            if (!item?.id) return;
            this.$router.push({name: "DepositRefundDetail", params: {id: item.id}});
        },
    },
};
</script>

<style scoped>
.deposit-refund-page {
    background: #fff;
    border-radius: 5px;
    min-height: 200px;
}

.deposit-refund-page__divider {
    padding: 0;
    margin: 0;
    border-color: #ebedf3;
}

.dialog-divider {
    margin-top: -12px;
    margin-bottom: 16px;
}

:deep(.request-refund-el-dialog .el-dialog__body) {
    padding: 18px 22px 20px;
}

.deposit-refund-page__body {
    padding: 16px 20px 24px;
}

.grid-filter {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px 40px;
    margin-bottom: 20px;
}

.display-flex-column {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.display-flex-column > span {
    font-size: 13px;
    font-weight: 500;
    color: #3f4254;
}

@media screen and (max-width: 1200px) {
    .grid-filter {
        grid-template-columns: 1fr 1fr;
    }
}

@media screen and (max-width: 768px) {
    .grid-filter {
        grid-template-columns: 1fr;
    }
}

.deposit-refund-table-wrap {
    overflow-x: auto;
    border-radius: 4px;
}

.deposit-refund-table {
    margin-bottom: 0;
    min-width: 1280px;
}

.deposit-refund-table thead tr {
    background-color: #f8f8f8;
}

.deposit-refund-table th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f8f8;
    font-size: 13px;
    font-weight: 600;
    color: #3f4254;
    white-space: nowrap;
    vertical-align: middle;
    padding: 12px 10px;
    border-color: #ebedf3 !important;
}

.deposit-refund-table td {
    font-size: 13px;
    color: #181c32;
    vertical-align: middle;
    padding: 10px;
    border-color: #ebedf3 !important;
}

.cell-student__name {
    font-weight: 500;
}

.cell-student__code {
    color: #7e8299;
}

.cell-amount {
    font-weight: 500;
    white-space: nowrap;
}

.empty-cell {
    text-align: center;
    padding: 32px 16px !important;
    color: #a1a5b7;
}

.action-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.refund-status-badge {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.2;
}

.refund-status--need {
    background: #fff7ed;
    color: #ea580c;
}

.refund-status--pending {
    background: #eff6ff;
    color: #2563eb;
}

.refund-status--rejected {
    background: #fef2f2;
    color: #dc2626;
}

.refund-status--waiting {
    background: #f5f3ff;
    color: #7c3aed;
}

.refund-status--completed {
    background: #f0fdf4;
    color: #16a34a;
}

.deposit-refund-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 24px;
    padding-top: 8px;
}

.deposit-refund-footer__paginate {
    flex: 1;
    display: flex;
    justify-content: center;
    min-width: 0;
}

.deposit-refund-footer__total {
    font-size: 14px;
    color: #3f4254;
    white-space: nowrap;
}

.deposit-refund-footer__total span {
    color: #0066ff;
    font-weight: 600;
    margin-left: 4px;
}
</style>
